// src/features/encounter/encounterSlice.ts
//       // ❷ 환자 정보 수정 API 호출
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { EncounterBaseSerializer } from "@/types/encounter"
// import { fetchEncounter, fetchCreateEncounter, fetchUpdateEncounter } from "@core/api/encounterApi"
import { fetchUpdateEncounter } from "@core/api/encounterApi"
// import { EncounterDxSerializer } from "@/types/encounterDx"
// import { fetchCreateEncounterDx } from "@core/api/encounterDxApi"

interface EncounterPayload {
  encounter: EncounterBaseSerializer | null
  encounterW: EncounterBaseSerializer | null
  lastLocalUpdatedDt: { encounterUuid: string; updatedDt: string; requestSequence: number } | null
  // encounterDxs: EncounterDxSerializer[] | null
  updateRequestSequence: number
  updateRequestSequenceById: Record<string, number>
  appliedUpdateSequenceByField: Record<string, number>
  loading: boolean
  error: string | null
}

const initialState: EncounterPayload = {
  encounter: null,
  encounterW: null,
  lastLocalUpdatedDt: null,
  // encounterDxs: null,
  updateRequestSequence: 0,
  updateRequestSequenceById: {},
  appliedUpdateSequenceByField: {},
  loading: false,
  error: null,
}

const encounterSlice = createSlice({
  name: "encounter",
  initialState,
  reducers: {
    setEncounter(state, action: PayloadAction<EncounterBaseSerializer | null>) {
      const encounterChanged = state.encounter?.encounterUuid !== action.payload?.encounterUuid
      const keepsLocalUpdatedDt = Boolean(
        state.lastLocalUpdatedDt &&
        state.lastLocalUpdatedDt.encounterUuid === action.payload?.encounterUuid &&
        state.lastLocalUpdatedDt.updatedDt === action.payload?.updatedDt
      )
      state.encounter = action.payload
      if (!keepsLocalUpdatedDt) {
        state.lastLocalUpdatedDt = null
      }
      if (encounterChanged) {
        state.updateRequestSequenceById = {}
        state.appliedUpdateSequenceByField = {}
      }
    },
    setEncounterW(state, action: PayloadAction<Partial<EncounterBaseSerializer>>) {
      state.encounterW = {
        // 이전 encounter 내용(있으면) + 새로운 데이터 덮어쓰기
        ...(state.encounterW ?? {}),
        ...action.payload,
      }
    },
    updateEncounterW(state, action: PayloadAction<Partial<EncounterBaseSerializer>>) {
      // state.encounterW가 null이거나 undefined라면 빈 객체로 초기화
      if (!state.encounterW) {
        state.encounterW = {} as EncounterBaseSerializer
      }

      // payload의 각 속성(key, value)마다, value가 undefined 또는 null이 아니면 업데이트
      Object.entries(action.payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          // Immer 덕분에 직접 변경해도 됩니다.
          ;(state.encounterW as any)[key] = value
        }
      })
    },

    updateEncounterWDate(state, action: PayloadAction<string>) {
      state.encounterW = {
        // 기존 encounter 내용(있으면) + selectedDate 덮어쓰기
        ...(state.encounterW ?? {}),
        encounterDate: action.payload,
      }
    },
    updateEncounterWInsuranceId(state, action: PayloadAction<number>) {
      state.encounterW = {
        // 기존 encounter 내용(있으면) + selectedDate 덮어쓰기
        ...(state.encounterW ?? {}),
        insuranceId: action.payload,
      }
    },
    updateEncounterWInsuranceUuid(state, action: PayloadAction<string>) {
      state.encounterW = {
        // 기존 encounter 내용(있으면) + selectedDate 덮어쓰기
        ...(state.encounterW ?? {}),
        insuranceUuid: action.payload,
      }
    },

    clearEncounterW(state) {
      state.encounterW = null
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
  },
  extraReducers: builder => {
    builder
      // fetchPatients 관련 처리
      // .addCase(fetchEncounter.pending, state => {
      //   state.loading = true
      //   state.error = null
      // })
      // .addCase(fetchEncounter.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.encounter = action.payload
      //   // console.log("fetchEncounter", action.payload)
      // })
      // .addCase(fetchEncounter.rejected, (state, action) => {
      //   state.loading = false
      //   state.encounter = null
      //   state.error = (action.payload as string) || action.error.message || "오류 "
      // })
      // fetchPatients 관련 처리
      // .addCase(fetchCreateEncounter.pending, state => {
      //   state.loading = true
      //   state.error = null
      // })
      // .addCase(fetchCreateEncounter.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.encounter = action.payload
      // })
      // .addCase(fetchCreateEncounter.rejected, (state, action) => {
      //   state.loading = false
      //   state.error = (action.payload as string) || action.error.message || "오류 "
      // })
      // fetchPatients 관련 처리
      // .addCase(fetchCreateEncounterDx.pending, state => {
      //   // state.loading = true
      //   // state.error = null
      // })
      // .addCase(fetchCreateEncounterDx.fulfilled, (state, action) => {
      //   // state.loading = false
      //   state.encounterDxs = action.payload
      // })
      // .addCase(fetchCreateEncounterDx.rejected, (state, action) => {
      //   // state.loading = false
      //   // state.error =
      //   //   (action.payload as string) || action.error.message || "오류 "
      // }) // fetchPatients 관련 처리
      // .addCase(fetchListEncounterDx.pending, state => {
      //   // state.loading = true
      //   // state.error = null
      // })
      // .addCase(fetchListEncounterDx.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.encounterDxs = action.payload
      //   // console.log("fetchListEncounterDx", action.payload)
      // })
      // .addCase(fetchListEncounterDx.rejected, (state, action) => {
      //   // state.loading = false
      //   // state.error =
      //   //   (action.payload as string) || action.error.message || "오류 "
      // }) // fetchPatients 관련 처리
      .addCase(fetchUpdateEncounter.pending, (state, action) => {
        // state.loading = true
        // state.error = null
        state.updateRequestSequence += 1
        state.updateRequestSequenceById[action.meta.requestId] = state.updateRequestSequence
      })
      .addCase(fetchUpdateEncounter.fulfilled, (state, action) => {
        // state.loading = false
        const requestSequence = state.updateRequestSequenceById[action.meta.requestId]
        const currentEncounter = state.encounter
        const responseEncounterUuid = action.payload.encounterUuid
        if (requestSequence !== undefined && currentEncounter && responseEncounterUuid && currentEncounter.encounterUuid === responseEncounterUuid) {
          const encounterUuid = responseEncounterUuid
          const responseUpdatedDt = action.payload.updatedDt
          const currentUpdatedDt = currentEncounter.updatedDt
          const responseIsOlder = Boolean(responseUpdatedDt && currentUpdatedDt && Date.parse(responseUpdatedDt) < Date.parse(currentUpdatedDt))
          if (responseUpdatedDt && (!currentUpdatedDt || Date.parse(responseUpdatedDt) > Date.parse(currentUpdatedDt))) {
            currentEncounter.updatedDt = responseUpdatedDt
            state.lastLocalUpdatedDt = {
              encounterUuid,
              updatedDt: responseUpdatedDt,
              requestSequence,
            }
          }
          if (!responseIsOlder) {
            Object.keys(action.meta.arg.encounterW).forEach(field => {
              if (
                field !== "encounterUuid" &&
                requestSequence > (state.appliedUpdateSequenceByField[`${encounterUuid}:${field}`] || 0) &&
                field in action.payload
              ) {
                ;(currentEncounter as any)[field] = (action.payload as any)[field]
                state.appliedUpdateSequenceByField[`${encounterUuid}:${field}`] = requestSequence
              }
            })
          }
        }
        delete state.updateRequestSequenceById[action.meta.requestId]
      })
      .addCase(fetchUpdateEncounter.rejected, (state, action) => {
        // state.loading = false
        // state.error =
        //   (action.payload as string) || action.error.message || "오류 "
        delete state.updateRequestSequenceById[action.meta.requestId]
      })
  },
})

export const {
  setEncounter,
  setEncounterW,
  updateEncounterW,
  updateEncounterWDate,
  updateEncounterWInsuranceId,
  updateEncounterWInsuranceUuid,
  clearEncounterW,
  setLoading,
  setError,
} = encounterSlice.actions

export default encounterSlice.reducer

